import Cells from "components/ReactTable/Components/Cells/Cells";

export default function Row({
    row,
    provided,
    innerRef,
    onSetSelectedRow,
    onSetSelectedRows,
    defaultFunction,
    selectRow,
    selectRows,
    rowClickCallback,
    rowDoubleClickCallback,
    showContextMenu,
    handleContextMenu,
    // Takes the row — keep the parameter so TS consumers infer (row) => boolean.
    isRowClickable = (row) => true, // eslint-disable-line no-unused-vars
}) {
    /** If row is draggable and provided was passed down, add these props to the row */
    const propsForDraggableRow = provided
        ? {
              ref: innerRef,
              ...provided.draggableProps,
              ...provided.dragHandleProps,
          }
        : {};

    /** If row is draggable and provided was passed down, add these styles to the row or they
     * get overridden by React Table's getRowProps()
     */
    const draggableStyleProps = provided ? provided.draggableProps.style : {};

    const hasTextSelection = () => {
        const selection = window.getSelection();
        return selection && selection.toString().length > 0;
    };

    const getOnClick = () => {
        // A parent can mark individual rows as having nothing to open. Returning null here also
        // drops the pointer cursor below, so the row stops advertising a click it won't honour.
        if (!isRowClickable(row)) {
            return null;
        }
        if (onSetSelectedRow !== defaultFunction) {
            return () => { if (!hasTextSelection()) { selectRow(row); } };
        } else if (rowClickCallback !== defaultFunction) {
            return () => { if (!hasTextSelection()) { rowClickCallback(row); } };
        } else if (onSetSelectedRows !== defaultFunction) {
            return () => { if (!hasTextSelection()) { selectRows(row); } };
        } else {
            return null;
        }
    };

    // Add row selection, click/double click callbacks, and run
    // context menu conditionally based on props from parent.
    // `key` comes out of the getter separately: React warns when a key arrives through a spread.
    const { key, ...rowProps } = row.getRowProps({
                className: row.isSelected ? "table-row-selected" : "",
                onClick: getOnClick(),
                onDoubleClick: () => rowDoubleClickCallback(row),
                onContextMenu: showContextMenu
                    ? (e) => handleContextMenu(e, row.original)
                    : null,
                style: {
                    cursor: getOnClick() ? "pointer" : "default",
                    ...draggableStyleProps,
                },
                ...propsForDraggableRow,
            });

    return (
        <tr key={key} {...rowProps}>
            <Cells row={row} />
        </tr>
    );
}
